<template>
  <section class="catalog-filter-block">
    <div class="catalog-filter-block__header" @click="isOpen = !isOpen">
      <slot name="header" />
      <div class="catalog-filter-block__arrow">
        <slot name="arrow">
          <DefArrowDown :active="isOpen" />
        </slot>
      </div>
    </div>
    <SlideUpDown v-model="isOpen">
      <div class="catalog-filter-block__footer">
        <slot />
      </div>
    </SlideUpDown>
  </section>
</template>

<script>
import DefArrowDown from '@components/Def/DefArrow/DefArrowDown.vue';
import SlideUpDown from 'vue3-slide-up-down';

export default {
  name: 'CatalogFilterBlock',
  components: { DefArrowDown, SlideUpDown },
  props: {
    result: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.result,
    };
  },
};
</script>

<style lang="scss" scoped>
.catalog-filter-block {
  padding: 16px 0;
  border-bottom: 1px solid #cacece;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    cursor: pointer;
    color: var(--color-main);
  }
  &__arrow {
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    color: #5f5f67;
  }
  &__footer {
    padding-top: 11px;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
